import type { CloudGateway } from '@core/cloud/gateway'

export type WithdrawalMode = 'ofd' | 'true_api'
export type WithdrawalReason = 'sale' | 'writeoff' | 'supplier_return' | 'other'
export type WithdrawalStatus = 'pending' | 'sent' | 'applied' | 'error' | 'skipped'

export interface CzWithdrawalRecord {
  id: string
  receipt_id: string | null
  line_id: string | null
  code: string
  mode: WithdrawalMode
  reason: WithdrawalReason
  status: WithdrawalStatus
  attempts: number
  last_error: string | null
}

export interface EnqueueWithdrawalInput {
  receiptId?: string | null
  sourceId?: string | null
  lineId?: string | null
  code: string
  pg?: string | null
  productCostCents?: number
  mode: WithdrawalMode
  reason: WithdrawalReason
}

/** Клиент очереди вывода кодов ЧЗ через backend. */
export class CzWithdrawalService {
  constructor(private readonly cloud: CloudGateway) {}

  public async enqueue(input: EnqueueWithdrawalInput): Promise<CzWithdrawalRecord> {
    const response = await this.cloud.request('/cz/withdrawals', {
      method: 'POST',
      body: {
        receipt_id: input.receiptId ?? null,
        source_id: input.sourceId ?? null,
        line_id: input.lineId ?? null,
        code: input.code,
        pg: input.pg ?? null,
        product_cost_cents: input.productCostCents ?? 0,
        mode: input.mode,
        reason: input.reason
      }
    })
    if (response.status !== 201) {
      const body = response.body as { error?: string } | null
      throw new Error(body?.error ?? `HTTP ${response.status}`)
    }
    return (response.body as { withdrawal: CzWithdrawalRecord }).withdrawal
  }

  public async retry(id: string): Promise<CzWithdrawalRecord> {
    const response = await this.cloud.request(`/cz/withdrawals/${encodeURIComponent(id)}/retry`, {
      method: 'POST'
    })
    if (response.status !== 200) {
      const body = response.body as { error?: string } | null
      throw new Error(body?.error ?? `HTTP ${response.status}`)
    }
    return (response.body as { withdrawal: CzWithdrawalRecord }).withdrawal
  }
}
